import { Component, Input, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { isNullOrUndefined } from 'src/app/common/utils/object.extensions';
import { EventTimeService } from 'src/app/modules/event-calendar/services/event.time.service';
import { OpeningHours } from 'src/app/modules/shared/models/visitor.place';
import { frontendSettingsSelector } from 'src/app/modules/shared/ngrx.stores/frontend.settings/selectors';
import {
  IAppState,
  IFrontendSettings,
} from 'src/app/modules/shared/ngrx.stores/frontend.settings/states';

@Component({
  selector: 'ig-opening-hours',
  templateUrl: './opening.hours.component.html',
  styleUrls: ['./opening.hours.component.scss'],
})
export class OpeningHoursComponent implements OnInit {
  @Input() public openingHours: OpeningHours;

  startAnimation = false;
  isExpanded = false;
  frontendSettings$: Observable<IFrontendSettings | null>;

  constructor(
    private _timeService: EventTimeService,
    private _store: Store<IAppState>
  ) {}

  ngOnInit(): void {
    this._store.pipe(select(frontendSettingsSelector)).subscribe((settings) => {
      // this.getIsOpenNow(settings?.customSettings.timezoneFormatter);
      this.openingHours.open_now = this.isPlaceOpenNow(
        this.openingHours.periods,
        settings.customSettings.timezoneFormatter
      );
    });

    setTimeout(() => {
      this.startAnimation = true;
    }, 800);
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  getIsOpenNow(timezoneFormatter: string) {
    if (!this.openingHours || !this.openingHours.periods) return;
    if (!timezoneFormatter) {
      console.log('timezoneFormatterDefault is null');
      return;
    }

    let hour;
    if (timezoneFormatter) {
      hour = this._timeService.getLocalHourByTZF(new Date(), timezoneFormatter);
    }

    if (isNullOrUndefined(hour)) return;

    const periods = this.openingHours.periods;

    // open 24 hours everyday
    if (
      periods.length === 1 &&
      periods[0].open.day === 0 &&
      periods[0].open.time === '0000'
    ) {
      this.openingHours.open_now = true;
      return;
    }

    const weekdayOfToday = new Date().getDay();
    const weekdayStatuses = periods.filter(
      (x) => x.open.day === weekdayOfToday && x.open.time && x.close.time
    );
    if (!weekdayStatuses.length) {
      this.openingHours.open_now = false;
    } else {
      for (const status of weekdayStatuses) {
        const open = parseInt(status.open.time, 10) / 100;
        let close = parseInt(status.close.time, 10) / 100;
        close = close === 0 ? 24 : close;

        const isOpen = open <= hour && close > hour;
        if (isOpen) {
          this.openingHours.open_now = isOpen;
          return;
        }
      }
      this.openingHours.open_now = false;
    }
  }

  isPlaceOpenNow(periods: any, timezoneFormatter: string) {
    return this._timeService.isPlaceOpenNow(periods, timezoneFormatter);
  }
}
